import React, { useContext, useEffect, useState } from "react";

import { Box, Paper, Snackbar, Stack } from "@mui/material";
import { TableContainer } from "@mui/material";
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";

import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell, StyledTableCellCabecalho, StyledTableHead, } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { IIntensidadeProdutiva, IProducao_forrageira } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { useLocation } from "react-router-dom";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { Alert } from "../../../Components/Alert/Alert";
import { format_strings_to_numbers, somaCampoHA, somaCampoTon } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";

interface IProducaoProps {
  tabela: IProducao_forrageira | undefined;
  setTabela: React.Dispatch<React.SetStateAction<IProducao_forrageira | undefined>>;
  set_obj_intensidade: React.Dispatch<React.SetStateAction<IIntensidadeProdutiva | undefined>>;
}

export const ProducaoForrageira: React.FC<IProducaoProps> = ({
  tabela,
  setTabela,
  set_obj_intensidade,
}) => {
  const location = useLocation();
  const auth = useContext(AuthContext);

  const [obj_editar, set_obj_editar] = useState<IProducao_forrageira>();

  const [isLoading, setIsLoading] = useState(true);
  const [createTable, setCreateTable] = useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [idToDelete, setIdToDelete] = useState<number | null | undefined>(0);
  const [editRow, setEditRow] = useState(false);

  const [message, setMessage] = React.useState("");
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);

  const message_apenas_numero = ("Apenas números são aceites");

  const [error_ha_culturas, set_error_ha_culturas] = useState<boolean>(false);
  const [error_ma_culturas, set_error_ma_culturas] = useState<boolean>(false);
  const [error_ha_silagem, set_error_ha_silagem] = useState<boolean>(false);
  const [error_ma_silagem, set_error_ma_silagem] = useState<boolean>(false);
  const [error_ha_outras, set_error_ha_outras] = useState<boolean>(false);
  const [error_ma_outras, set_error_ma_outras] = useState<boolean>(false);
  const [error_ha_pastagem, set_error_ha_pastagem] = useState<boolean>(false);
  const [error_ma_pastagem, set_error_ma_pastagem] = useState<boolean>(false);
  const [error_ha_regadio, set_error_ha_regadio] = useState<boolean>(false);
  const [error_ma_regadio, set_error_ma_regadio] = useState<boolean>(false);
  const [error_ha_sequeiro, set_error_ha_sequeiro] = useState<boolean>(false);
  const [error_ma_sequeiro, set_error_ma_sequeiro] = useState<boolean>(false);

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);


  const handleCloseDialog = () => {
    set_error_ha_culturas(false)
    set_error_ma_culturas(false)
    set_error_ha_silagem(false)
    set_error_ma_silagem(false)
    set_error_ha_outras(false)
    set_error_ma_outras(false)
    set_error_ha_pastagem(false)
    set_error_ma_pastagem(false)
    set_error_ha_regadio(false)
    set_error_ma_regadio(false)
    set_error_ha_sequeiro(false)
    set_error_ma_sequeiro(false)
    handleCancelar()
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  async function getTabela() {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, `/get_Producao_forrageira_id_rosto/${location.state.id_identificacao}`);

      if (res.status === 200) {
        setTabela(res.data.result[0])
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getExtra", error, true);
      // setMessage("Erro ao efetuar a sua operação!");
      // setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getTabela();
    })();
  }, []);

  const handleCancelar = () => {
    setEditRow(false);
    setCreateTable(false);
    set_obj_editar(undefined);
  }

  //criar
  const onInputChange = (event: any) => {
    const { name, value, } = event.target;
    set_flag_editado(true)

    if (name === "ha_culturas") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ha_culturas(true);
      } else {
        set_error_ha_culturas(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ma_culturas") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ma_culturas(true);
      } else {
        set_error_ma_culturas(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ha_silagem") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ha_silagem(true);
      } else {
        set_error_ha_silagem(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ma_silagem") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ma_silagem(true);
      } else {
        set_error_ma_silagem(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ha_outras") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ha_outras(true);
      } else {
        set_error_ha_outras(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ma_outras") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ma_outras(true);
      } else {
        set_error_ma_outras(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ha_pastagem") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ha_pastagem(true);
      } else {
        set_error_ha_pastagem(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ma_pastagem") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ma_pastagem(true);
      } else {
        set_error_ma_pastagem(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ha_regadio") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ha_regadio(true);
      } else {
        set_error_ha_regadio(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ma_regadio") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ma_regadio(true);
      } else {
        set_error_ma_regadio(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ha_sequeiro") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ha_sequeiro(true);
      } else {
        set_error_ha_sequeiro(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "ma_sequeiro") {
      if (/[a-zA-Z]/.test(value)) {
        set_error_ma_sequeiro(true);
      } else {
        set_error_ma_sequeiro(false);
        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else {
      set_obj_editar((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: value,
      }));
    }




  };

  const handleSaveTabela = async () => {
    if (obj_editar === undefined
    ) {
      setMessage("Preencha a tabela antes de gravar!");
      setOpenSnackError(true);
    } else
      try {
        let res = await post(auth.token.cookie_token, "new_Producao_forrageira", {
          payload: {
            id_producao: 0,
            ha_culturas: obj_editar.ha_culturas === undefined ? null : obj_editar.ha_culturas,
            ma_culturas: obj_editar.ma_culturas === undefined ? null : obj_editar.ma_culturas,
            ha_silagem: obj_editar.ha_silagem === undefined ? null : obj_editar.ha_silagem,
            ma_silagem: obj_editar.ma_silagem === undefined ? null : obj_editar.ma_silagem,
            ha_outras: obj_editar.ha_outras === undefined ? null : obj_editar.ha_outras,
            ma_outras: obj_editar.ma_outras === undefined ? null : obj_editar.ma_outras,
            ha_pastagem: obj_editar.ha_pastagem === undefined ? null : obj_editar.ha_pastagem,
            ma_pastagem: obj_editar.ma_pastagem === undefined ? null : obj_editar.ma_pastagem,
            ha_regadio: obj_editar.ha_regadio === undefined ? null : obj_editar.ha_regadio,
            ma_regadio: obj_editar.ma_regadio === undefined ? null : obj_editar.ma_regadio,
            ha_sequeiro: obj_editar.ha_sequeiro === undefined ? null : obj_editar.ha_sequeiro,
            ma_sequeiro: obj_editar.ma_sequeiro === undefined ? null : obj_editar.ma_sequeiro,
            total_ha: somaCampoHA(obj_editar),
            id_identificacao: location.state.id_identificacao,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          set_obj_intensidade(res.data.result[0])
          setTabela(res.data.result[1])
          set_flag_editado(false)

          set_obj_editar(undefined);
          setCreateTable(false);
          setEditRow(false)
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSave", error, true);
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
        setIsLoading(false);
      }
  }

  /********** EDITAR LINHA *************/
  const handleEdit = (obj: IProducao_forrageira) => {
    set_obj_editar(obj);
    setEditRow(true);
  };

  const handleUpdatetabela = async () => {
    if (obj_editar !== undefined) {
      try {
        let res = await post(auth.token.cookie_token, `update_Producao_forrageira`, {
          payload: {
            id_producao: obj_editar.id_producao,
            ha_culturas: obj_editar.ha_culturas === undefined ? null : obj_editar.ha_culturas,
            ma_culturas: obj_editar.ma_culturas === undefined ? null : obj_editar.ma_culturas,
            ha_silagem: obj_editar.ha_silagem === undefined ? null : obj_editar.ha_silagem,
            ma_silagem: obj_editar.ma_silagem === undefined ? null : obj_editar.ma_silagem,
            ha_outras: obj_editar.ha_outras === undefined ? null : obj_editar.ha_outras,
            ma_outras: obj_editar.ma_outras === undefined ? null : obj_editar.ma_outras,
            ha_pastagem: obj_editar.ha_pastagem === undefined ? null : obj_editar.ha_pastagem,
            ma_pastagem: obj_editar.ma_pastagem === undefined ? null : obj_editar.ma_pastagem,
            ha_regadio: obj_editar.ha_regadio === undefined ? null : obj_editar.ha_regadio,
            ma_regadio: obj_editar.ma_regadio === undefined ? null : obj_editar.ma_regadio,
            ha_sequeiro: obj_editar.ha_sequeiro === undefined ? null : obj_editar.ha_sequeiro,
            ma_sequeiro: obj_editar.ma_sequeiro === undefined ? null : obj_editar.ma_sequeiro,
            total_ha: somaCampoHA(obj_editar),
            id_identificacao: location.state.id_identificacao,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });

        if (res.status === 200) {
          setMessage("Registado com sucesso!");
          set_flag_editado(false)

          set_obj_intensidade(res.data.result[0])
          setTabela(res.data.result[1])
          set_obj_editar(undefined);
          setEditRow(false);
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleUpdatetabela", error, true);
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
        setIsLoading(false);
      }
    } else {
      setMessage("Selecione uma tabela para editar!");
      setOpenSnackError(true);
    }
  };

  const handlesave = () => {
    if (editRow === true) {
      handleUpdatetabela();
    } else {
      handleSaveTabela();
    }
  }

  // DELETE
  const handleClickOpenDelete = (id: number | null) => {
    setIdToDelete(id);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      if (idToDelete !== null) {
        setIsLoading(true);

        let res = await del(auth.token.cookie_token, `/delete_Producao_forrageira/${idToDelete}`);

        if (res.status === 200) {
          set_obj_intensidade(res.data.result)
          setMessage("Registo eliminado com sucesso!");
          setOpenDelete(false);
          setIdToDelete(null);
          setTabela(undefined);
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao eliminar o registo!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  return (
    <>
      {isLoading ?
        <LoadingVulpes />
        :
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <table style={{ width: "100%" }}>
            <TableHead>
              <TableRow>
                <StyledTableCellCabecalho
                  colSpan={11}
                  sx={{ fontWeight: 700, fontSize: 18 }}
                >
                  2 - Plano de Alimentação de Bovinos
                </StyledTableCellCabecalho>
              </TableRow>
              <TableRow>
                <StyledTableCellCabecalho
                  colSpan={2}
                  sx={{ fontWeight: 600, fontSize: 14, }}>
                  2.1. Produção Forrageira (preenchimento facultativo - quando
                  exista Plano Forrageiro da Exploração)
                </StyledTableCellCabecalho>
              </TableRow>
              <TableRow>
                <StyledTableHead>Tipo de alimento grosseiro</StyledTableHead>
                <StyledTableHead>ha</StyledTableHead>
                <StyledTableHead>Matéria Seca (ton)</StyledTableHead>
                <TableCell>
                  {tabela?.id_identificacao === undefined && createTable === false && editRow === false ?
                    <Stack direction="row" sx={{ justifyContent: "end" }}>
                      <BarraDeFerramentas
                        mostrarBotaoNovo
                        textoBotaoNovo="Registar"
                        aoClicarNovo={() => setCreateTable(true)}
                      />
                    </Stack>
                    :
                    tabela !== undefined && createTable === false && editRow === false ?
                      <Stack direction="row" sx={{ justifyContent: "end" }}>
                        <ButtonCadernos
                          mostrarBotaoEditar
                          aoClicarEditar={() => handleEdit(tabela)}
                          mostrarBotaoApagar
                          aoClicarApagar={() => handleClickOpenDelete(tabela.id_producao)}
                        />
                      </Stack>
                      :
                      <Box sx={{ justifyContent: "end", display: "flex" }}>
                        <ButtonCadernos
                          mostrarBotaoGravar
                          aoClicarGravar={() => handlesave()}
                          mostrarBotaoCancelar

                          aoClicarCancelar={() => {
                            if (flag_editado) {
                              set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)

                            } else {

                              handleCancelar()
                            }

                          }}
                        />
                      </Box>
                  }
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {createTable || editRow ?
                <>
                  <TableRow>
                    <StyledTableHead>Culturas forrageiras</StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="ha_culturas"
                        value={obj_editar?.ha_culturas === undefined || obj_editar?.ha_culturas === null ? '' : obj_editar?.ha_culturas.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ha_culturas}
                        helperText={error_ha_culturas ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="ma_culturas"
                        value={obj_editar?.ma_culturas === undefined || obj_editar?.ma_culturas === null? '' : obj_editar?.ma_culturas.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ma_culturas}
                        helperText={error_ma_culturas ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead> Silagem</StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="ha_silagem"
                        value={obj_editar?.ha_silagem === undefined || obj_editar?.ha_silagem === null? '' : obj_editar?.ha_silagem.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ha_silagem}
                        helperText={error_ha_silagem ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="ma_silagem"
                        value={obj_editar?.ma_silagem === undefined || obj_editar?.ma_silagem === null? '' : obj_editar?.ma_silagem.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ma_silagem}
                        helperText={error_ma_silagem ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead> Outras forragens</StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="ha_outras"
                        value={obj_editar?.ha_outras === undefined || obj_editar?.ha_outras === null? '' : obj_editar?.ha_outras.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ha_outras}
                        helperText={error_ha_outras ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="ma_outras"
                        value={obj_editar?.ma_outras === undefined || obj_editar?.ma_outras === null? '' : obj_editar?.ma_outras.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ma_outras}
                        helperText={error_ma_outras ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>Pastagem</StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="ha_pastagem"
                        value={obj_editar?.ha_pastagem === undefined || obj_editar?.ha_pastagem === null? '' : obj_editar?.ha_pastagem.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ha_pastagem}
                        helperText={error_ha_pastagem ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="ma_pastagem"
                        value={obj_editar?.ma_pastagem === undefined || obj_editar?.ma_pastagem === null? '' : obj_editar?.ma_pastagem.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ma_pastagem}
                        helperText={error_ma_pastagem ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>Regadio</StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="ha_regadio"
                        value={obj_editar?.ha_regadio === undefined || obj_editar?.ha_regadio === null? '' : obj_editar?.ha_regadio.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ha_regadio}
                        helperText={error_ha_regadio ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="ma_regadio"
                        value={obj_editar?.ma_regadio === undefined || obj_editar?.ma_regadio === null? '' : obj_editar?.ma_regadio.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ma_regadio}
                        helperText={error_ma_regadio ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>Sequeiro</StyledTableHead>
                    <StyledTableCell>
                      <CustomTextField
                        name="ha_sequeiro"
                        value={obj_editar?.ha_sequeiro === undefined || obj_editar?.ha_sequeiro === null? '' : obj_editar?.ha_sequeiro.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ha_sequeiro}
                        helperText={error_ha_sequeiro ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="ma_sequeiro"
                        value={obj_editar?.ma_sequeiro === undefined|| obj_editar?.ma_sequeiro === null ? '' : obj_editar?.ma_sequeiro.toString().replace('.', ',')}
                        onChange={onInputChange}
                        error={error_ma_sequeiro}
                        helperText={error_ma_sequeiro ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                  </TableRow>

                </>
                :
                <>
                  <TableRow>
                    <StyledTableHead>Culturas forrageiras</StyledTableHead>
                    <StyledTableCell>{tabela?.ha_culturas === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ha_culturas)}</StyledTableCell>
                    <StyledTableCell>{tabela?.ma_culturas === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ma_culturas)}</StyledTableCell>
                  </TableRow><TableRow>
                    <StyledTableHead> Silagem</StyledTableHead>
                    <StyledTableCell>{tabela?.ha_silagem === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ha_silagem)} </StyledTableCell>
                    <StyledTableCell>{tabela?.ma_silagem === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ma_silagem)}</StyledTableCell>
                  </TableRow><TableRow>
                    <StyledTableHead> Outras forragens</StyledTableHead>
                    <StyledTableCell>{tabela?.ha_outras === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ha_outras)}</StyledTableCell>
                    <StyledTableCell>{tabela?.ma_outras === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ma_outras)}</StyledTableCell>
                  </TableRow><TableRow>
                    <StyledTableHead>Pastagem</StyledTableHead>
                    <StyledTableCell>{tabela?.ha_pastagem === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ha_pastagem)} </StyledTableCell>
                    <StyledTableCell>{tabela?.ma_pastagem === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ma_pastagem)}</StyledTableCell>
                  </TableRow><TableRow>
                    <StyledTableHead>Regadio</StyledTableHead>
                    <StyledTableCell>{tabela?.ha_regadio === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ha_regadio)} </StyledTableCell>
                    <StyledTableCell>{tabela?.ma_regadio === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ma_regadio)}</StyledTableCell>
                  </TableRow><TableRow>
                    <StyledTableHead>Sequeiro</StyledTableHead>
                    <StyledTableCell>{tabela?.ha_sequeiro === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ha_sequeiro)} </StyledTableCell>
                    <StyledTableCell>{tabela?.ma_sequeiro === undefined ? '' : formatarNumero_recebido_com_casa_decimais(tabela?.ma_sequeiro)}</StyledTableCell>
                  </TableRow><TableRow>
                    <StyledTableHead>TOTAL</StyledTableHead>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                      {formatarNumero_recebido_com_casa_decimais(somaCampoHA(tabela))}
                    </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                      {formatarNumero_recebido_com_casa_decimais(somaCampoTon(tabela))}
                    </StyledTableCell>
                  </TableRow>
                </>
              }

            </TableBody>
            <ConfirmDialog
              open={openDelete}
              onClose={() => setOpenDelete(false)}
              onConfirm={handleDelete}
              message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
              open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
              onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
              onConfirm={() => handleCloseDialog()}
              message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
          </table>
        </TableContainer>
      }
    </>
  );
};
